import React, { useEffect, useState, useContext } from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { fetchArticlesByPromotion } from "../../../api/articles";
import ProductsTable from "../../../components/products-table/ProductsTable";
import { toast } from "../../../helpers/smu-alerts/smu-lerts";
import { fetchProductsByFaldonId } from "../../../api/files";
import { StoreContext } from "../../../store/StoreContext";
import { useLocation } from "react-router-dom";
import { resolveUserTienda } from "../../../helpers";

const brand = process.env.REACT_APP_BRAND || "UNI";

const SkirtDetail = () => {
  const location = useLocation();
  const filter = location.state?.filter;
  const { faldonId } = useParams();
  const { isAdmin, loggedUser } = useContext(StoreContext);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!faldonId) {
      setProducts([]);
      return toast({ icon: "error", title: "Error en Id de Promoción." });
    }
    setLoading(true);
    // fetchArticlesByPromotion(brand, _code)
    //   .then(({ data, error }) => {
    //     if (!!error) throw new Error(error?.message);
    //     setArticles(data.O_ARTICULOS);
    //   })
    //   .catch((err) => {
    //     console.error(err);//toast({ icon: "error", title: err });
    //   })
    //   .finally(() => setLoading(false));
    // TODO: Implementar la logica para traer los productos del faldon
    const tienda = isAdmin && filter?.tienda ? filter?.tienda : filter?.tienda ? filter?.tienda : null;
    fetchProductsByFaldonId(decodeURIComponent(faldonId), tienda ? tienda : resolveUserTienda(isAdmin, loggedUser), loggedUser?.username)
    .then(({ data, error }) => {
      if (!!error) throw new Error(error?.message);
      setProducts(data);
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => setLoading(false));
  }, []);

  return (
    <Row>
      <Col col={12} className="mb-4">
        <ProductsTable
          products={products}
          faldonId={faldonId}
          loading={loading}
          filter={filter || null}
        />
      </Col>
    </Row>
  );
};

export default SkirtDetail;